import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';

const Protected = ({ children }) => {
  const { user } = UserAuth();

  //this redirects to login if user is not logged in
  if (user && user.isPreviouslyAuthenticated === false) {
    return <Navigate to='/login' />;
  }

  return children;
};

export default Protected;